import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import { setData } from "rivals/shared/utils/qa";
import styles from "./TextAreaInput.module.scss";
import { OwnProps } from "./types";

const TextAreaInput: FunctionComponent<OwnProps> = ({
  className,
  data = "",
  disabled = false,
  feedback = "",
  hint = "",
  htmlFor = "",
  maxLength,
  label = "",
  onBlur,
  onChange,
  placeholder = "",
  readOnly = false,
  required = false,
  spellCheck,
  value
}): ReactElement => {
  const inputClasses = classNames(styles.input, {
    [styles.feedbackBorder]: feedback
  });

  return (
    <div className={className}>
      <label
        className={styles.label}
        htmlFor={htmlFor}
        {...setData(data, "label")}
      >
        {label}
        <textarea
          className={inputClasses}
          disabled={disabled}
          maxLength={maxLength}
          name={htmlFor}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
          spellCheck={spellCheck}
          value={value}
          {...setData(data, "input")}
        />
        {hint && <div className={styles.hint}>{hint}</div>}
        {feedback && (
          <div
            className={styles.feedback}
            dangerouslySetInnerHTML={{ __html: feedback }}
          />
        )}
      </label>
    </div>
  );
};

export default TextAreaInput;
